export default __webpack_public_path__ + "static/media/logo26.92e3559b.svg";